module.exports = __webpack_public_path__ + "img/lowerabs-ecto-mesomorph-male.6fdfc528.svg";